import type { StateCreator } from 'zustand';
import { HALLOWEEN_CONFIG } from '@/modules/promotions/components/HeadlinePromo/Halloween/config';
import { OKTOBERFEST_CONFIG } from '@/modules/promotions/components/HeadlinePromo/Oktoberfest/config';
import { PUMPKIN_KINGDOM_CONFIG } from '@/modules/promotions/components/HeadlinePromo/PumpkinKingdom/config';
import { SOLAR_PASS_CONFIG } from '@/modules/promotions/components/HeadlinePromo/SolarPass/config';
import type {
  CommonStoreType,
  HeadlinePromoState,
} from '@/store/commonStore/types';

export const useHeadlinePromoSlice: StateCreator<
  CommonStoreType,
  [],
  [],
  HeadlinePromoState
> = () => ({
  headlinePromoConfigs: [
    OKTOBERFEST_CONFIG,
    PUMPKIN_KINGDOM_CONFIG,
    SOLAR_PASS_CONFIG,
    HALLOWEEN_CONFIG,
  ],
});
